module.exports = __webpack_public_path__ + "img/pluto109.0337da85.jpg";